import z from "zod";

import { getRequiredAppSetting } from "../shared/index.ts";
import platforms from "./platforms.ts";
import type { ILoggingClient, IPlatform } from "./types.ts";

const KnownConfig = z
  .object({
    console: z.object({}),
    sentry: z.object({
      dsn: z.string(),
      env: z.string().optional(),
    }),
  })
  .partial();

export const createLoggingClients = () => {
  const configJson = getRequiredAppSetting(import.meta.env.REACT_APP_LOGGING_CONFIG, "LOGGING_CONFIG");
  let configRaw: unknown;
  try {
    configRaw = JSON.parse(configJson);
  } catch (error) {
    console.error("Failed to parse logging config: %O", configJson);
    return [];
  }

  // maybe separately validate each platform?
  const configResult = KnownConfig.safeParse(configRaw);
  if (!configResult.success) {
    console.warn("Invalid logging config, no logging: %O", configResult.error.format());
    return [];
  }

  // parse strictly just to warn about unknown providers
  const configStrictResult = KnownConfig.strict().safeParse(configRaw);
  if (!configStrictResult.success) {
    console.warn("Logging config has unknown providers: %O", configStrictResult.error.format());
  }

  const config = configResult.data;

  const loggingClients: ILoggingClient[] = [];

  for (const [name, platformConfig] of Object.entries(config)) {
    console.info("Init logging client %s", name);
    const platform = platforms[name as keyof typeof config] as IPlatform<unknown>;
    const client = platform.init(platformConfig);
    if (client) {
      loggingClients.push(client);
    }
  }

  return loggingClients;
};
